import {
    guideClickOnElement,
    guideWaitForElement,
    guideClickOnElementInTopActivity,
    guideFillInput,
    guideWaitForElementLong,
    guideWaitForValue,
    guideWaitForElementByXPath, clickOnTab, guideWaitForElementByXPathWithoutTime
} from "@/components/dashboard/guides/guidNavigation";
import {isBelowBreakpoint} from "@/utils/Dom";
import EventBus from "@/utils/EventBus";


export function createAddInspirationGuideSteps(initialMenu) {
    let menu = initialMenu;
    return [
        {
            target: '#dark-navbar',
            header: {
                title: 'Hello There',
            },
            content: "I’ll guide you through creating a new inspiration. Let's get started.",
            imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Inspirations-Tour.png",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    EventBus.$emit('openMainMenu');
                    menu="mobile-"
                }
                else {
                    menu=""
                }
            }
        },
        {
            target: () => `#${menu}m-plm`,
            previous: true,
            content: "Click on the PRODUCT LIFECYCLE module.",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    menu="mobile-"
                    EventBus.$emit('openMainMenu');
                    await guideClickOnElement(`#${menu}m-plm`);
                } else {
                    menu=""
                    await guideClickOnElement('#m-plm');
                }
                await sleep(500);
            }
        },
        {
            target: () => `#${menu}plm-form-Inspiration`,
            previous: true,
            content: "Now, click on the Inspiration section.",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    menu="mobile-"
                    await guideClickOnElement(`[id='${menu}plm-form-Inspiration'] a`)
                } else {
                    menu=""
                    await guideClickOnElement("[id='plm-form-Inspiration'] a")
                }
                await guideWaitForElement('[data-test-path="grid-header-new-Inspirations"]');
                await sleep(500);
            }
        },
        {
            target: '[data-test-path="grid-header-new-Inspirations"]',
            previous: true,
            content: "Let’s create a new inspiration. Click the New button.",
            beforeNext: async () => {
                await guideClickOnElement('[data-test-path="grid-header-new-Inspirations"]')
                await guideWaitForElementByXPath("//a[@role='tab' and normalize-space(text())='Design']")
                await sleep(500);
            }
        },
        {
            targetXPath: "//a[@role='tab' and normalize-space(text())='Design']",
            previous: true,
            content: "Here, you can create a design using the AI options below or upload your own project.",

        },
        {
            target: ' [data-test-path="type-of-product"]',

            previous: true,
            content: "Let's try generating our first inspiration. Choose the right options for your project.",

        },
        {
            target: '#input',
            previous: true,
            content: "Enter a description of the clothing you want to generate. For example: Polo Cotton T-shirt with White Collar.",
            beforeNext: async () => {
                await guideFillInput('#input', "Polo Cotton T-shirt with White Collar");
                await sleep(500);
            }
        },
        {
            target: '[data-test-path="generate-image-inspiration"]',
            previous: true,
            content: "Click Generate.",
            beforeNext: async () => {
                await guideClickOnElement('[data-test-path="generate-image-inspiration"]');
                await sleep(500);
                await guideWaitForElementByXPath("//div[contains(@class, 'custom-container') " +
                    "and contains(@class, 'card') and .//span[contains(@class, 'sr-only') and normalize-space(text())='Generowanie...']]")

            }
        },
        {
            target: '[data-test-path="generate-image-inspiration"]',
            previous: false,
            content: "It will take a while. Please wait a moment.",
            beforeNext: async () => {
                await guideWaitForElementByXPathWithoutTime('//button[@data-test-path="generate-image-inspiration" and not(@disabled)]')
                await sleep(500);
            },
        },
        {
            targetXPath: "//a[@role='tab' and normalize-space(text())='Marketing Description']",
            previous: false,
            content: "Now, let's move on to the next section: Marketing Description.",
            beforeNext: async () => {
                await clickOnTab("Marketing Description")
                await sleep(500);
            }
        },
        {
            targetXPath: "//a[@role='tab' and normalize-space(text())='Marketing Description']",
            previous: true,
            content: "Here, you can add or generate various marketing descriptions for your project using AI, which you can later use in your work.",
        },
        {
            targetXPath: "//a[@role='tab' and normalize-space(text())='Design']",
            previous: true,
            content: "Now, let's move back to the Design section.",
            beforeNext: async () => {
                await clickOnTab("Design")
                await sleep(500);
            }
        },
        {
            target: '[data-test-path="create-product-from-inspiration"]',
            previous: true,
            content: 'Now, you can create a project from your inspiration.',
        },
        {
            target: '[data-test-path="create-product-from-inspiration"]',
            header: {
                title: 'Finish',
            },
            content: "You have successfully added new inspiration. Now, try creating something unique on your own.",
        },
    ]
}